interface Preference {
  color: string;
  title: string;
  explanation: string;
}

class PreferenceData {
  private static readonly allPreferences: Preference[] = [
    {
      'color': '#ff0300',
      'title': 'Sie haben Untergewicht',
      'explanation': 'Achten Sie daher unbedingt auf Ihr Körpergewicht. Für normale Erwachsene liegt die Grenze zum'
        + 'Untergewicht bei einem Body-Mass-Index von 18,5. Liegen Sie darunter, sollten Sie sich von einem Arzt '
        + 'untersuchen und beraten lassen. In Deutschland haben 2 Prozent aller Bürger einen BMI, der Untergewicht anzeigt.'
    },
    {
      'color': '#47a823',
      'title': 'Sie haben Normalgewicht',
      'explanation': 'Durch Ihre Lebensweise haben Sie Ihr Gewicht sehr gut unter Kontrolle. Machen Sie weiter so. '
        + 'Beobachten Sie aber auch weiterhin die Entwicklung Ihres Körpergewichts und behalten Sie Ihre bewusste '
        + 'Ernährungsweise bei. Deutschlandweit haben 46 Prozent der Deutschen einen BMI im Normalbereich.'
    },
    {
      'color': '#ff7900',
      'title': 'Sie haben leichtes Übergewicht',
      'explanation': 'Besonders bei zusätzlichen Beschwerden wie Gelenkschmerzen oder Herz-Kreislauf-Problemen sollten Sie '
        + 'versuchen, abzunehmen. Am Besten, Sie sprechen mit Ihrem Hausarzt über Möglichkeiten, wie Sie langfristig Ihr '
        + 'Idealgewicht erreichen können.'
    },
    {
      'color': '#ff0300',
      'title': 'Sie haben deutliches Übergewicht',
      'explanation': 'Ihr BMI ist deutlich höher als normal. Sie sollten versuchen, Ihr Gewicht zu reduzieren. Achten Sie '
        + 'auch auf Ihre Ernährung und ausreichend Bewegung. Welche Möglichkeiten Sie haben, um einen niedrigeren BMI und '
        + 'Ihr Idealgewicht zu erreichen, könnnen Sie auch zusammen mit Ihrem Hausarzt analysieren.'
    },
    {
      'color': '#ff0300',
      'title': 'Sie haben sehr starkes Übergewicht',
      'explanation': 'Das kann viele Ursachen haben: z.B. unausgewogene Ernährung oder Bewegungsmangel. Um die Gründe besser '
        + 'zu verstehen und Ihren BMI zu reduzieren, sollten Sie mit Ihrem Hausarzt sprechen.'
    },
    {
      'color': '#ff0300',
      'title': 'Sie haben extremes Übergewicht',
      'explanation': 'Sprechen Sie unbedingt mit Ihrem Arzt über Möglichkeiten, Ihr Gewicht zu reduzieren und einen '
        + 'niedrigeren BMI zu erreichen. Langfristig sind Sie deutlich anfälliger für Krankheiten wie Diabetes, '
        + 'Gelenkprobleme und Kreislaufstörungen. Sie sollten auch regelmäßig Ihr Gewicht und Ihren BMI kontrollieren.'
    }
  ];

  public static getPreferenceForBMI(bmi: number, isWoman: boolean): Preference {
    let index;

    if (isWoman) {
      switch (true) {
        case (bmi < 17.5): index = 0;
          break;
        case (bmi <= 24): index = 1;
          break;
        case (bmi <= 29): index = 2;
          break;
        case (bmi <= 34): index = 3;
          break;
        case (bmi <= 36.5): index = 4;
          break;
        default: index = 5;
          break;
      }
    } else {
      switch (true) {
        case (bmi < 18.5): index = 0;
          break;
        case (bmi <= 24.9): index = 1;
          break;
        case (bmi <= 29.9): index = 2;
          break;
        case (bmi <= 34.9): index = 3;
          break;
        case (bmi <= 39.9): index = 4;
          break;
        default: index = 5;
          break;
      }
    }

    return this.allPreferences[index];
  }
}

export {PreferenceData};
